<template>
  <div>
    <base-header v-once></base-header>
    {{ $route.query.id }}
    <br />
    <br />이름 :
    <input v-model="form.name" placeholder="이름" />
    <br />설명 :
    <textarea v-model="form.desc" placeholder="설명"></textarea>
    <br />성인 :
    <input type="checkbox" v-model="form.adult" />
    <br />-----------성별---------
    <br />남성(
    <input type="radio" value="M" v-model="form.sex" />)
    여성(
    <input type="radio" value="F" v-model="form.sex" />)
    <br />-----------국적---------
    <br />
    <select v-model="form.country">
      <option disabled value>국적을 선택하세요.</option>
      <option value="K">대한민국</option>
      <option value="A">미국</option>
      <option value="J">일본</option>
    </select>
    <br />-----------동적 컴포넌트---------
    <component v-for="field in fields" v-bind:is="field.type" :key="field.id" ref="child"></component>
    <br />
    <button @click="onAddComponents">자녀추가</button>
    <br />
    <br />
    <button @click.enter="onClick">A</button>
    <br />
    <br />
    <button @click.enter="onCallParent">팝업일때 부모로 데이터 전송하는 예</button>
    <br>
    <br><br>
    <br><br>
    <br><br>
    <br>
    <qrcode-vue :value="value" :size="size" level="H" />
    <br><br><br><br><br><br>
    <button @click.enter="setShake('CSTMR_REG')">쉐이크 설정(CSTMR_REG)</button><br>
    <button @click.enter="setShake('QR_AUTH')">쉐이크 설정(QR_AUTH)</button><br>
    <button @click.enter="setShake('NONE')">쉐이크 설정(NONE)</button><br>
    <button @click.enter="getShake">쉐이크 조회</button><br><br><br><br>
    <button @click.enter="test">테스트</button><br>
  </div>
</template>
<script>
import DynamicComponen from '@/components/sample/DynamicComponent.vue';
var QrcodeVue = () => import(/* webpackChunkName: "QrcodeVue" */ 'qrcode.vue');
// import QrcodeVue from 'qrcode.vue'

export default {
  name: "Detail",
  components: {
    DynamicComponen,
    QrcodeVue
  },
  watch: {
    '$store.state.ui.appdb': function()  {
      var key = this.$store.state.ui.appdb.key;
      alert(key);
      var value = this.$store.state.ui.appdb.value;
      alert(value);
    },
    '$store.state.ui.child': function() {
      var childName = this.$store.state.ui.child.name;
      alert(childName); 
    }
  },
  data() {
    return {
      msg: "Detail Component",
      fields: [],
      fieldsCount: 0,
      form: {
        name: "",
        desc: "",
        adult: true,
        sex: "M",
        country: '',
        childs: []
      },
      value: 'https://google.co.kr',
      size: 150,
    };
  },
  mounted() {
    this.$on('onRemoveComponent', this.onRemoveComponent);
  },
  methods: {
    onClick() {
      console.log(this.form);

      // 자식-컴포넌트 데이터 조
      // this.form.childs = [];
      // var childs = this.$refs.child;
      // for(var i=0;i<childs.length;i++) {
      //   var child = childs[i].$data.child;
      //   this.form.childs.push({'name':child.name, 'sex':child.sex});
      // }
      // console.log('this.form.childs', this.form.childs);
      // console.log('this.form.childs to jsonString', JSON.stringify(this.form.childs));

      var items = [];
      var childs = this.$refs.child;
      for(var i=0;i<childs.length;i++) {
        var child = childs[i].$data.child;
        items.push({'name':child.name, 'sex':child.sex});
      }
      console.log('items', items);
      console.log('items to jsonString', JSON.stringify(items));

      var parameters = {
        id: "TESTID",
        items: JSON.stringify(items)
      };
      this.$api.sample
        .complex(parameters)
        .then(function(data) {
          console.log("Query.vue <onClick.data>", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    onAddComponents() {
      this.fields.push({
        'type': 'dynamic-componen',
        id: this.fieldsCount++
      });
    },
    onRemoveComponent(id) {
      console.log('Query.vue <onRemoveComponent.id>', id);
      var index = this.fields.findIndex(f => f.id === id);
      this.fields.splice(index, 1);
    },
    onCallParent() {
      var child = {
        name: 'pop-query--222',
        data: {
          id : 123,
          title: '제목233332',
          body: '본문11111'
        }
      }
      this.$utils.nativeIf.outbound.sendChildData(child);
      this.$utils.nativeIf.outbound.close();
    },
    setShake(type) {
      console.log(type);
      var data = {};
      data.type = type; 
      data.url  = '/myCstmr/myCstmrReg';
      this.$utils.nativeIf.outbound.setAppDB("shake", JSON.stringify(data));
    },
    getShake() {
      this.$utils.nativeIf.outbound.getAppDB("test");
    },
    test() {
      window.app.$root.$utils.nativeIf.inbound.getAppDb('test', '1234' );
    }
  },
  created: function() {
    console.log(this.$options.name, "테스트", this.$route.query);
  }
};
</script>
